<template lang="pug">
  v-list(
    v-if="items"
    color="transparent")
    v-radio-group(:value="items.findIndex(({ value }) => value)")
      utility-action-state(
        v-for="({ label, icon, onClick, value }, index) in items"
        :key="index"
        :action="onClick || (() => itemsOnClick({ index }))")
        template(#default="{ loading, trigger }")
          v-list-item(
            @click="trigger"
            :disabled="!isChoice && (loading || (!value && maxSelectedItemsReached))")
            v-list-item-action(v-if="value !== undefined")
              v-checkbox(
                v-if="!isChoice"
                :disabled="!value && maxSelectedItemsReached"
                v-model="value")
              v-radio(
                v-else
                :value="index")
            v-list-item-content {{ label }}
            v-list-item-icon(v-if="icon")
              v-progress-circular(
                v-if="loading"
                :size="24"
                :width="2"
                indeterminate)
              v-icon(v-else) {{ icon }}
</template>

<script>
import UtilityActionState from '@iez/components/utility/action-state'

export default {
  components: {
    UtilityActionState
  },

  props: {
    items: Array,
    maxSelectedItemsReached: Boolean,
    isChoice: Boolean
  },

  setup (props) {
    const itemsOnClick = ({ index }) => {
      const valueBefore = props.items[index].value
      if (props.isChoice) {
        props.items.forEach(item => {
          item.value = false
        })
      }
      props.items[index].value = !valueBefore
    }

    return {
      itemsOnClick
    }
  }
}
</script>
